import { createForensicSearchResultsEndPoint, 
  getForensicSearchStatusEndPoint, 
  deleteForensicSearchResultsEndPoint, 
  getRecentForensicSearchesEndPoint,
getImageFromImageIndexForensicSearchResultsEndPoint } from "../configuration";
import axiosInstance from "../global/axiosInterceptor";

export const getForensicSearchStatus = async (payload, activeSession) => {
  try {
    const payload_forensicobject = {
      'id':payload?.id,
    }
    const searchStatusResponse = await axiosInstance.post(getForensicSearchStatusEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: payload_forensicobject,
    });
    return searchStatusResponse;
    } catch (error) {
    throw error;
  }
};

export const getRecentForensicSearches = async (payload, activeSession) => {
  try {
    // id present  -> one specific search (SearchResult page): accountname + resourceidentifier
    // id absent   -> every recent search (HS index page): accountname + userid + filter
    const requestBody = payload?.id
      ? {
          accountname: activeSession.accountId,
          resourceidentifier: { id: payload.id },
        }
      : {
          accountname: activeSession.accountId,
          userid: activeSession.userId,
          filter: {
            "$limitnumber": 10,
            "$sort": [{ "field": "createdon", "order": "desc" }]
          },
        };
    const searchStatusResponse = await axiosInstance.post(getRecentForensicSearchesEndPoint(), requestBody);
    // let sdata = searchStatusResponse?.data.map(m => {m.totalhits = 5; return m;})
    // searchStatusResponse.data = sdata;
    return searchStatusResponse;
    } catch (error) {
    return {'status': error?.response?.status || 500, 'statusText': error?.response?.data?.message || error?.message};
  }
};


export const createForensicSearch = async (payload, activeSession) => {
  if (!payload?.target || !payload?.filters || !activeSession?.accountId) {
    const error = new Error('Missing required parameters for forensic search');
    error.statusCode = 400;
    throw error;
  }
  try {
    const payload_forensicobject = {
      'targets': payload?.target,
      'filters':payload?.filters,
      'customdata': payload?.customdata,
    }


    const searchResultResponse = await axiosInstance.post(createForensicSearchResultsEndPoint(), {
      accountname: activeSession.accountId,
      forensicobject: payload_forensicobject,
    });
    return searchResultResponse;


// return [{"ccdId":"4471191d-1468-6946-f323-1f2fd81e1ffd",
//   "fovids":['f8ea3002-b6d6-4b14-a9e6-e8403b593ac2',
//      'c917fcb3-51f9-4034-957e-5e04e3e014a5', 
//      '5816c104-a7a9-4808-a6dd-c36a44d90ffb', 
//      '0db59e11-059f-4b43-bfdb-0e209e8a47f3', 
//     '33bb2ad9-10f1-4a4f-aa84-404e992eb228',
//      '421495bd-271d-4bb5-8da7-0290569588e4',
//      '7accbe3b-c967-4e95-a739-6e7e0c212dc2']},
//   {"ccdId":"64b12260-bc93-68ec-fe40-9dd1e7cf55f8",
//     "fovids":['60910be0-0a3b-482c-b9b1-7629599d01e3',
//      '39988769-c157-49b6-981a-85ccf6e2770a',
//       'b33e77ad-2d45-4bf9-8a43-2a8d6cff435b',
//        '424b1476-7b9f-425d-8749-9d8b6c109516', 
//        '84dca2b0-7903-4418-b94c-219abdc0fd78',
//         'ca2dd75a-bdaf-4085-aa47-a89990f71aba', 
//         '2ad13ffb-3d19-40ad-9703-0fe91fb52dd5',
//          '94dc1e15-d5bb-452b-8030-55b5b956a8b5',
//           'de051bc4-9258-46a6-a6b4-2e8965387741',
//           '3ce8c13e-30f9-461c-80b2-e7b00074058b',
//            '9ed76a4a-7178-42e0-988f-71f4492e46c1', 
//     '0359aac6-458d-48be-b59b-dea46d758191',
//      'f40d17ba-d625-4fcc-b213-1d49520b43e5',
//       '1427a90e-1dcc-49dc-8223-06bd84240f4a']},
  // {"ccdId":"",
  //   "fovids":['8f6ad699-e130-4135-a945-1b7db8c93258', 
  //   '0d3fdbe6-dfee-4963-9f2b-f4b988d41c5b', 
  //   '2b753b0d-5a79-4a05-a668-3de7d68ab591', 
  //   '9022d650-9fe6-4c56-8889-750d8a240704', 
  //   '3045dd42-1f59-481f-a4ce-f1cd980d21e4']}
  
  // ] 

  } catch (error) {
    const responseData = error?.errorResponse?.data || error?.response?.data;
    return {'status': error?.statusCode || error?.response?.status || error?.errorResponse?.status || 500, 'statusText': responseData?.original_error_description || responseData?.message || error?.message};
  }
};

export const deleteForensicSearch = async (payload, activeSession) => {
  if (!payload?.id || !activeSession?.accountId) {
    throw new Error('Missing required parameters for forensic search');
  }
  try {
    const payload_forensicobject = {
      'id': payload?.id,
    }


    const searchResultResponse = await axiosInstance.post(deleteForensicSearchResultsEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: payload_forensicobject,
    });
    return searchResultResponse;

  } catch (error) {
    return {'status': error?.response?.status || 500, 'statusText': error?.response?.data?.message || error?.message};
  }
};

export const getImagesFromImageIndexes = async (payload, activeSession) => {
  if (!payload?.id || !activeSession?.accountId) {
    throw new Error('Missing required parameters for forensic search');
  }
  try {
    const payload_forensicobject = {
      'id': payload?.id,
    }
    const searchResultResponse = await axiosInstance.post(getImageFromImageIndexForensicSearchResultsEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: payload_forensicobject,
      searchindex: payload.searchIndex
    });
    return searchResultResponse;

  } catch (error) {
    return {'status': error?.response?.status || 500, 'statusText': error?.response?.data?.message || error?.message};
  }
};